import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BigCard from "../../../general/BigCard";
import styles from "./EducationL2.module.css";
import LeafletMap from "./maps/LeafletMap";
import { EducationStore } from "./EducationStore";

function EducationL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);

  const nivelEscolaridadeValue = EducationStore(
    (state) => state.nivelEscolaridadeValue
  );

  const matriculaEscolaValue = EducationStore(
    (state) => state.matriculaEscolaValue
  );

  const qualidadeEscolasRuraisValue = EducationStore(
    (state) => state.qualidadeEscolasRuraisValue
  );

  const setEducationMapImage = EducationStore((state) => state.setEducationMapImage);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia] = await Promise.all([
          Api.getNumeroPropriedadesEducacao(
            distrito,
            nivelEscolaridadeValue,
            matriculaEscolaValue,
            qualidadeEscolasRuraisValue
          ),
          Api.getAreaMediaDistritoEducacao(
            distrito,
            nivelEscolaridadeValue,
            matriculaEscolaValue,
            qualidadeEscolasRuraisValue
          ),
        ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    nivelEscolaridadeValue,
    matriculaEscolaValue,
    qualidadeEscolasRuraisValue,
  ]);

  return (
    <div className={styles.educationL2}>
      <div className={styles.cards}>
        <div className={styles.bigcard}>
          <BigCard
            name={"Propriedades"}
            value={numeroPropriedades?.value ?? "0"}
          />
        </div>
        <div className={styles.bigcard}>
          <BigCard
            name={"Área Média"}
            value={areaMedia?.value?.toFixed(2) ?? "0.0"}
          />
        </div>
      </div>
      <div className={styles.map}>
        <LeafletMap distrito={distrito} onImageReady={setEducationMapImage}/>
      </div>
    </div>
  );
}

export default EducationL2;
